import React, { useState } from "react";
import HelperBox from './helperBox';

function ExportMenu(props) {
    const [name, setName] = useState("my-custom-skin");

    function handleInput(e) {
        setName(e.target.value);
    }

    function handleClick(size) {
        props.handleDownload(name, size);
    }

    return (
        <div>
            <div style={{display: "inline-flex", alignItems: "center"}}>
                <h2>Export</h2>
                <HelperBox />
            </div>
            <input id="inputBox" className="typeField" onChange={handleInput} value={name}></input>
            <h3 onClick={() => handleClick(1)}>Download Skin (1x only)</h3>
            <h3 onClick={() => handleClick(2)}>Download Skin (2x only)</h3>
        </div>
    )
}

export default ExportMenu;